/* lp-ugc-reel — <lp-ugc-reel>: customer video cards.
   Active card: on mobile the centred card of the snap row (IntersectionObserver band on the track); on desktop
   spotlight the card last clicked or hovered, with every card's --lp-ugc-reel-k set to its distance from it so the
   CSS glides them. Autoplay (data-autoplay centre | all | none): a card's <video> gets its src the first time it needs
   to play, so nothing downloads for cards that stay posters; playback pauses off screen and under reduced motion.
   Viewer: tapping a card opens the <dialog> with the full rendition and sound; mute, pause, progress, prev / next
   (neighbours' posters), Escape or backdrop tap to close, arrow keys to move. Card videos pause while it is open.
   Quote cards (.lp-ugc-reel__card--quote) sit in the same row: they take part in the carousel (swipe, dots,
   spotlight, arrows) but the viewer steps through the video cards only. Spotlight with more than five cards keeps
   the active card centred and marks cards more than two away .is-far (hidden); hover no longer moves it (click or
   the arrows). [data-lp-step] arrows move one card. Row carousel (.lp-ugc-reel--scroll, desktop): the arrows scroll
   the track by one card and disable at either end; hovering a card makes it active (plays it) without moving. */
(function () {
  'use strict';
  if (window.customElements.get('lp-ugc-reel')) return;

  function motionOK() { return window.LP ? window.LP.motionOK : !window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  var slice = Array.prototype.slice;

  class LpUgcReel extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-lp-track]');
      this.cards = slice.call(this.querySelectorAll('.lp-ugc-reel__card'));
      this.vcards = this.cards.filter(function (c) { return !!c.querySelector('[data-lp-open]'); });
      this.navs = slice.call(this.querySelectorAll('[data-lp-step]'));
      this.dots = slice.call(this.querySelectorAll('[data-lp-dot]'));
      this.viewer = this.querySelector('[data-lp-viewer]');
      this.full = this.querySelector('[data-lp-full]');
      if (!this.cards.length) return;
      this.mode = this.dataset.autoplay || 'centre';
      this.active = parseInt(this.dataset.active, 10) || 0;
      this.start = this.active;
      this.restart = this.hasAttribute('data-restart');
      this.inView = false;
      this.desktop = window.matchMedia('(min-width: 48rem)');
      this.spotlight = this.classList.contains('lp-ugc-reel--spotlight');
      this.scrollRow = this.classList.contains('lp-ugc-reel--scroll');

      this.onClick = function (e) {
        var open = e.target.closest('[data-lp-open]');
        if (open && self.contains(open)) {
          var i = parseInt(open.dataset.lpOpen, 10);
          /* desktop spotlight: a wing card comes to the centre first; the centre card opens the viewer */
          if (self.spotlight && self.desktop.matches && i !== self.active) { self.setActive(i, true); return; }
          self.open(i); return;
        }
        /* a quote card: on desktop spotlight a wing comes to the centre */
        var qc = e.target.closest('.lp-ugc-reel__card--quote');
        if (qc && self.contains(qc) && self.spotlight && self.desktop.matches && !qc.classList.contains('is-active')) { self.setActive(parseInt(qc.dataset.lpIndex, 10), true); return; }
        var step = e.target.closest('[data-lp-step]');
        if (step && self.contains(step)) {
          var dir = parseInt(step.dataset.lpStep, 10);
          if (self.scrollRow && self.desktop.matches) { self.scrollStep(dir); return; }
          self.setActive(Math.max(0, Math.min(self.cards.length - 1, self.active + dir)), true); return;
        }
        var dot = e.target.closest('[data-lp-dot]');
        if (dot && self.contains(dot)) { self.setActive(parseInt(dot.dataset.lpDot, 10), true); return; }
        if (e.target.closest('[data-lp-close]')) { self.close(); return; }
        if (e.target.closest('[data-lp-mute]')) { self.full.muted = !self.full.muted; self.syncViewer(); return; }
        if (e.target.closest('[data-lp-toggle]')) { if (self.full.paused) self.full.play().catch(function () {}); else self.full.pause(); return; }
        var jump = e.target.closest('[data-lp-jump]');
        if (jump) { self.show(self.current + parseInt(jump.dataset.lpJump, 10)); return; }
        if (self.viewer && e.target === self.viewer) self.close(); /* backdrop */
      };
      this.addEventListener('click', this.onClick);
      this.onOver = function (e) {
        var card = e.target.closest('.lp-ugc-reel__card');
        if (!card || !self.desktop.matches || card.classList.contains('is-active')) return;
        /* a long spotlight would slide under the pointer and chain hovers: click or arrows only */
        if (self.spotlight && self.cards.length <= 5) self.setActive(parseInt(card.dataset.lpIndex, 10), false);
        else if (self.scrollRow) self.setActive(parseInt(card.dataset.lpIndex, 10), false);
      };
      this.addEventListener('mouseover', this.onOver);
      this.onKey = function (e) {
        if (!self.viewer || !self.viewer.open) return;
        if (e.key === 'ArrowRight') self.show(self.current + 1);
        else if (e.key === 'ArrowLeft') self.show(self.current - 1);
        else if (e.key === ' ') { e.preventDefault(); if (self.full.paused) self.full.play().catch(function () {}); else self.full.pause(); }
      };
      document.addEventListener('keydown', this.onKey);
      if (this.full) {
        this.onTime = function () { var bar = self.querySelector('[data-lp-progress]'); if (bar && self.full.duration) bar.style.width = (self.full.currentTime / self.full.duration * 100) + '%'; };
        this.onState = function () { self.viewer.classList.toggle('is-paused', self.full.paused); var t = self.querySelector('[data-lp-toggle]'); if (t) t.setAttribute('aria-label', self.full.paused ? 'Play' : 'Pause'); };
        this.onEnded = function () { self.show(self.current + 1); };
        this.full.addEventListener('timeupdate', this.onTime);
        this.full.addEventListener('play', this.onState); this.full.addEventListener('pause', this.onState);
        this.full.addEventListener('ended', this.onEnded);
        this.onDialogClose = function () { self.full.pause(); self.full.removeAttribute('src'); self.full.load(); self.playCards(); };
        this.viewer.addEventListener('close', this.onDialogClose);
      }
      /* theme editor: selecting a Video block brings it to the centre */
      this.onBlockSelect = function (e) {
        var card = e.target && e.target.closest ? e.target.closest('.lp-ugc-reel__card') : null;
        if (card && self.contains(card)) self.setActive(parseInt(card.dataset.lpIndex, 10), true);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.layout();
      this.slideTo(this.active, 'auto'); /* the middle card starts centred on mobile */
      this.onResize = function () { self.layout(); };
      this.desktop.addEventListener('change', this.onResize);
      this.watchCentre();
      this.watchScreen();
      if (this.track) {
        var nt;
        this.onTrackScroll = function () { clearTimeout(nt); nt = setTimeout(function () { self.updateNav(); }, 60); };
        this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
        window.addEventListener('resize', this.onTrackScroll);
      }
      this.updateNav();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('mouseover', this.onOver);
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.desktop.removeEventListener('change', this.onResize);
      if (this.centreIO) this.centreIO.disconnect();
      if (this.screenIO) this.screenIO.disconnect();
      if (this.viewer && this.onDialogClose) this.viewer.removeEventListener('close', this.onDialogClose);
      clearTimeout(this.slideTimer);
      if (this.track && this.onTrackScroll) { this.track.removeEventListener('scroll', this.onTrackScroll); window.removeEventListener('resize', this.onTrackScroll); }
      this.cards.forEach(function (c) { var v = c.querySelector('video'); if (v) v.pause(); });
    }

    /* ---- active card ---- */
    layout() {
      var self = this, n = this.cards.length, wide = n > 5;
      this.cards.forEach(function (c, i) {
        c.style.setProperty('--lp-ugc-reel-k', i - self.active);
        c.classList.toggle('is-active', i === self.active);
        c.classList.toggle('is-far', wide && Math.abs(i - self.active) > 2);
      });
      /* spotlight: with an even count the fan is lopsided around the active card; shift it so the whole fan is centred.
         A long row (more than five cards) keeps the active card centred instead and hides the far cards. */
      if (this.track) this.track.style.setProperty('--lp-ugc-reel-shift', wide ? '0' : (this.active - (n - 1) / 2).toFixed(2));
      this.updateNav();
      this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === self.active); d.setAttribute('aria-selected', i === self.active ? 'true' : 'false'); });
      this.playCards();
    }
    /* arrows: the row carousel follows its scroll position, the spotlight and phones the active card */
    updateNav() {
      var self = this, n = this.cards.length, t = this.track;
      if (!this.navs || !this.navs.length) return;
      if (this.scrollRow && this.desktop.matches && t) {
        var max = t.scrollWidth - t.clientWidth;
        this.navs.forEach(function (b) { var d = parseInt(b.dataset.lpStep, 10); b.disabled = d < 0 ? t.scrollLeft <= 2 : t.scrollLeft >= max - 2; });
      } else {
        this.navs.forEach(function (b) { var d = parseInt(b.dataset.lpStep, 10); b.disabled = d < 0 ? self.active <= 0 : self.active >= n - 1; });
      }
    }
    /* row carousel: one card per press */
    scrollStep(dir) {
      var t = this.track, card = this.cards[0]; if (!t || !card) return;
      var gap = parseFloat(getComputedStyle(t).columnGap) || 0;
      t.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: motionOK() ? 'smooth' : 'auto' });
    }
    setActive(i, slide) {
      if (i < 0 || i >= this.cards.length || i === this.active) return;
      this.active = i;
      this.layout();
      if (slide) this.slideTo(i, motionOK() ? 'smooth' : 'auto');
    }
    /* mobile row: bring a card to the middle; the centre observer is held off while the row is moving */
    slideTo(i, behavior) {
      var t = this.track, card = this.cards[i], self = this;
      if (this.desktop.matches || !t || !card || t.scrollWidth <= t.clientWidth + 2) return;
      this.sliding = true; clearTimeout(this.slideTimer);
      this.slideTimer = setTimeout(function () { self.sliding = false; }, 900);
      t.scrollTo({ left: card.offsetLeft - (t.clientWidth - card.offsetWidth) / 2, behavior: behavior });
    }
    /* mobile: the card in the middle of the row becomes active as the shopper swipes */
    watchCentre() {
      var t = this.track, self = this;
      if (!t || !('IntersectionObserver' in window)) return;
      this.centreIO = new IntersectionObserver(function (entries) {
        if (self.sliding || self.desktop.matches) return;
        var hit = entries.filter(function (e) { return e.isIntersecting; }).pop();
        if (hit) self.setActive(parseInt(hit.target.dataset.lpIndex, 10), false);
      }, { root: t, rootMargin: '0px -49% 0px -49%', threshold: 0 });
      this.cards.forEach(function (c) { self.centreIO.observe(c); });
    }
    watchScreen() {
      var self = this;
      if (!('IntersectionObserver' in window)) { this.inView = true; this.playCards(); return; }
      this.screenIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var was = self.inView; self.inView = e.isIntersecting;
          if (self.inView && !was && self.restart) self.restartStart();
          self.playCards();
        });
      }, { threshold: 0.2 });
      this.screenIO.observe(this);
    }

    /* restart on view: back to the start card, its video from the beginning */
    restartStart() {
      if (this.viewer && this.viewer.open) return;
      var i = this.start, card = this.cards[i]; if (!card) return;
      var v = card.querySelector('video');
      if (v) { try { v.currentTime = 0; } catch (x) {} }
      if (this.active !== i) this.setActive(i, false);
      if (this.desktop.matches) { if (this.scrollRow && this.track && this.track.scrollLeft > 2) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'auto' }); }
      else this.slideTo(i, 'auto');
      this.updateNav();
    }

    /* ---- inline playback ---- */
    playCards() {
      var self = this, viewing = this.viewer && this.viewer.open;
      this.cards.forEach(function (c, i) {
        var v = c.querySelector('video'); if (!v) return;
        var want = self.inView && !viewing && motionOK() && self.mode !== 'none' && (self.mode === 'all' || i === self.active);
        if (want) {
          /* a narrow card (phones) gets the small rendition; wider cards the 1080p one */
          if (!v.getAttribute('src')) { v.src = (v.dataset.sd && c.clientWidth * (window.devicePixelRatio || 1) <= 600) ? v.dataset.sd : v.dataset.src; }
          v.play().then(function () { c.classList.add('is-playing'); }).catch(function () {});
        } else {
          v.pause(); c.classList.remove('is-playing');
        }
      });
    }

    /* ---- viewer ---- */
    /* i: the card index; the viewer works over the video cards */
    open(i) {
      if (!this.viewer || !this.viewer.showModal) return;
      var j = this.vcards.indexOf(this.cards[i]); if (j < 0) return;
      this.cards.forEach(function (c) { var v = c.querySelector('video'); if (v) v.pause(); c.classList.remove('is-playing'); });
      this.viewer.showModal();
      this.full.muted = false;
      this.show(j);
    }
    close() { if (this.viewer && this.viewer.open) this.viewer.close(); }
    show(i) {
      var vc = this.vcards, n = vc.length; if (!n) return;
      i = (i + n) % n;
      this.current = i;
      var btn = vc[i].querySelector('[data-lp-open]'), self = this;
      this.full.pause();
      this.full.poster = btn.dataset.poster || '';
      this.full.src = btn.dataset.full || btn.dataset.src;
      this.full.play().catch(function () {});
      var cap = this.querySelector('[data-lp-caption]'), meta = vc[i].querySelector('.lp-ugc-reel__meta');
      if (cap) cap.textContent = meta ? meta.textContent.trim() : '';
      slice.call(this.querySelectorAll('[data-lp-jump]')).forEach(function (j) {
        var k = (i + parseInt(j.dataset.lpJump, 10) + n) % n, img = j.querySelector('img');
        j.hidden = n < 2;
        if (img) img.src = vc[k].querySelector('[data-lp-open]').dataset.poster || '';
      });
      this.syncViewer();
    }
    syncViewer() {
      var m = this.querySelector('[data-lp-mute]');
      if (m) { m.setAttribute('aria-pressed', this.full.muted ? 'true' : 'false'); m.setAttribute('aria-label', this.full.muted ? 'Unmute' : 'Mute'); }
    }
  }
  window.customElements.define('lp-ugc-reel', LpUgcReel);
})();
